module.exports = __webpack_public_path__ + "media/img/aztec-scan-widget-854ae77b.png";